import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  HostListener,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-colleges',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './colleges.component.html',
  styleUrls: ['./colleges.component.scss'],
})
export class CollegesComponent implements OnInit, AfterViewInit, OnDestroy {
  // template-compatible string flags
  display: any = 'none';
  displayDelete: any = 'none';

  // internal boolean flags
  isModalOpen: boolean = false;
  isDeleteOpen: boolean = false;

  showAdd = false;
  showEdit = false;

  // component properties (kept for some template compatibility where needed)
  collegeName: any;
  city: any;
  stateid: any;
  address: any;
  stateData: any;
  disrictData: any;
  phonenumber: any;
  emailAddress: any;

  fileToUpload: File | null = null;
  imageUrl: any; // base64 preview of main image
  colleges: any;
  id: any;
  searchData: any;
  allData: any;

  addCollegeForm: UntypedFormGroup;

  showErr = false;

  scopeId: any;
  scopeIdArray: any[] = [];
  fees: any;

  scopeAmount: any;

  objectives: any;

  error_messages = {
    clgImg: [{ type: 'required', message: 'Please select image' }],
    clgName: [{ type: 'required', message: 'Please enter college name' }],
    clgAddress: [{ type: 'required', message: 'Please enter address' }],
    clgDistrict: [{ type: 'required', message: 'Please select district' }],
    clgState: [{ type: 'required', message: 'Please select state' }],
    objectivesVal: [
      { type: 'required', message: 'Please enter objectives of college' },
    ],
    trustFeesVal: [{ type: 'required', message: 'Please enter fees' }],
    feesVal: [{ type: 'required', message: 'Please enter trust fees' }],
    checkVal: [{ type: 'required', message: 'Please select courses' }],
    preVal: [{ type: 'required', message: 'Please select preferences' }],
    hint: [{ type: 'required', message: 'Please enter hint' }],
  };

  images: string[] = []; // gallery preview base64 strings
  galleryFiles: File[] = []; // gallery File objects
  degreeType: any;
  ug: any;
  ugfees: any;
  pgcourse: any;
  pgfees: any;
  phdcourse: any;
  video: any;
  deleteErr: any;
  scopeData: any;
  adminName: any;
  adminImage: any;
  collegeid: number;
  wholeCollegeData: any;
  max: any;

  newData: any[] = [];

  isShowAll: boolean = false;
  imageData: any[];
  videos: any[];
  videoData: any[] = [];
  courses: any[];
  courseData: any[] = [];

  showData = false;
  showNodata = false;

  searchval: any;

  imageTrueFalse: boolean = false;
  payload: any;

  @ViewChild('boxCollege', { static: false }) boxCollege: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  preferenceVal: any;
  gridApi: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    // reactive form definition
    this.addCollegeForm = this.formBuilder.group({
      clgImg: new UntypedFormControl(null, Validators.required), // main image file (File object)
      colgImg: new UntypedFormControl(null), // gallery files (File[] optional)
      clgName: new UntypedFormControl('', Validators.required),
      clgAddress: new UntypedFormControl('', Validators.required),
      clgDistrict: new UntypedFormControl('', Validators.required),
      clgState: new UntypedFormControl('', Validators.required),
      objectivesVal: new UntypedFormControl('', Validators.required),
      trustFeesVal: new UntypedFormControl('', Validators.nullValidator),
      feesVal: new UntypedFormControl('', Validators.nullValidator),
      checkVal: new UntypedFormControl(false, Validators.requiredTrue),
      preVal: new UntypedFormControl(1, Validators.required),
      hint: new UntypedFormControl('', Validators.required),
    });

    // admin info from localStorage (defensive)
    try {
      const admin = JSON.parse(localStorage.getItem('adminDetails') || 'null');
      const adminData = admin ? JSON.parse(admin) : null;
      this.adminName = adminData?.[0]?.name;
      this.adminImage = adminData?.[0]?.image;
    } catch (e) {
      this.adminName = null;
      this.adminImage = null;
    }

    if (!this.adminImage) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }

    this.collegeid = 1;
  }

  async ngOnInit() {
    this.spinner.show();
    this.addCollegeForm.reset();

    // Get All College
    try {
      const servicePathCollege = this.utils.getApiConfigs('college');
      let resp: any = await this.commonservice.invokeService(
        servicePathCollege[1].method,
        servicePathCollege[1].path,
        ''
      );
      this.spinner.hide();
      if (resp?.status_code == '200') {
        this.colleges = resp.data || [];
        if (!this.colleges || this.colleges.length === 0) {
          this.showNodata = true;
          this.showData = false;
        } else {
          this.showData = true;
          this.showNodata = false;
          for (let i = 0; i < this.colleges.length; i++) {
            this.colleges[i]['displayDate'] = moment().format('DD-MM-YYYY');
          }
        }
      }
    } catch (err) {
      this.spinner.hide();
      console.error('ngOnInit -> colleges fetch error', err);
    }

    // Get States, Districts, Scope, Details (sequential)
    try {
      const servicePathstate = this.utils.getApiConfigs('state');
      const respState: any = await this.commonservice.invokeService(
        servicePathstate[1].method,
        servicePathstate[1].path,
        ''
      );
      if (respState?.status_code == '200') {
        this.stateData = respState.data || [];
      }
    } catch (err) {
      console.error('error fetching states', err);
    }

    try {
      const servicePathDistrict = this.utils.getApiConfigs('district');
      const respDistrict: any = await this.commonservice.invokeService(
        servicePathDistrict[1].method,
        servicePathDistrict[1].path,
        ''
      );
      if (respDistrict?.status_code == '200') {
        this.disrictData = respDistrict.data || [];
      }
    } catch (err) {
      console.error('error fetching districts', err);
    }

    // initialize searchData and defaults
    this.searchData = Array.isArray(this.colleges) ? this.colleges.slice() : [];
    for (let i = 0; i < (this.searchData || []).length; i++) {
      if (!this.searchData[i].image) {
        this.searchData[i].image = 'assets/avatar.png';
      }
    }

    // load scopes early (so add modal has them ready)
    try {
      await this.loadScopesIfNeeded();
    } catch (err) {
      console.error('initial scope load error', err);
    }

    try {
      const resp: any = await this.commonservice.getMethod(
        `individualcollegedetails?college_id=${this.collegeid}`,
        ''
      );
      if (resp?.status_code == '200') {
        this.wholeCollegeData = resp.data;
      }
    } catch (err) {
      console.error('error fetching individual col details', err);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      try {
        this.searchInput?.nativeElement?.focus();
      } catch (e) {}
    }, 200);
  }

  ngOnDestroy() {
    try {
      document.body.classList.remove('modal-open');
    } catch (e) {}
  }

  @HostListener('window:keydown.escape', ['$event'])
  onEscapePressed(event: KeyboardEvent) {
    if (this.isModalOpen || this.isDeleteOpen) {
      this.onCloseHandled();
    }
  }

  private setModalOpen(open: boolean) {
    this.isModalOpen = !!open;
    this.display = this.isModalOpen ? 'block' : 'none';
  }

  private setDeleteOpen(open: boolean) {
    this.isDeleteOpen = !!open;
    this.displayDelete = this.isDeleteOpen ? 'block' : 'none';
  }

  closeAllModals() {
    try {
      this.setModalOpen(false);
      this.setDeleteOpen(false);
      this.showAdd = false;
      this.showEdit = false;
      this.addCollegeForm?.reset();
      this.images = [];
      this.galleryFiles = [];
    } finally {
      try {
        document.body.classList.remove('modal-open');
      } catch (e) {}
    }
  }

  /**
   * Ensure scopeData is loaded and normalized (each scope gets a `check` boolean).
   * Returns a Promise that resolves once scopeData is ready.
   */
  async loadScopesIfNeeded(): Promise<void> {
    // if already loaded, just ensure check property exists
    if (Array.isArray(this.scopeData) && this.scopeData.length > 0) {
      this.scopeData.forEach((s: any) => {
        if (s.check === undefined) s.check = false;
      });
      return;
    }

    // fetch from API (defensive)
    try {
      const servicePathscope = this.utils.getApiConfigs('scope');
      const resp: any = await this.commonservice.invokeService(
        servicePathscope[1].method,
        servicePathscope[1].path,
        ''
      );
      if (resp && resp.status_code === '200') {
        this.scopeData = resp.data || [];
        // ensure each item has .check boolean for consistent template behavior
        this.scopeData.forEach((s: any) => (s.check = !!s.check));
        // update change detection so modal shows checkboxes
        try {
          this.cdr.detectChanges();
        } catch (e) {}
      } else {
        this.scopeData = [];
      }
    } catch (err) {
      console.error('loadScopesIfNeeded error', err);
      this.scopeData = [];
    }
  }

  // main image handler - sets preview and reactive form control to File
  handleFileInput(fileList: FileList | null) {
    if (!fileList || fileList.length === 0) return;
    try {
      const file = fileList.item(0) as File;
      this.fileToUpload = file;
      this.addCollegeForm.get('clgImg')?.setValue(file);
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
        this.imageTrueFalse = true;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    } catch (err) {
      console.error('handleFileInput error', err);
    }
  }

  // gallery images handler
  handleFileInputs(event: any) {
    if (!event?.target?.files?.length) return;
    try {
      const files: FileList = event.target.files;
      this.images = [];
      this.galleryFiles = [];
      for (let i = 0; i < files.length; i++) {
        const f = files[i] as File;
        this.galleryFiles.push(f);
        const reader = new FileReader();
        reader.onload = (ev: any) => {
          this.images.push(ev.target.result);
          this.cdr.detectChanges();
        };
        reader.readAsDataURL(f);
      }
      this.addCollegeForm.get('colgImg')?.setValue(this.galleryFiles);
    } catch (err) {
      console.error('handleFileInputs error', err);
    }
  }

  onMouseOver(e: any) {
    try {
      (<HTMLDivElement>this.boxCollege.nativeElement).style.pointerEvents =
        'auto';
      (<HTMLDivElement>this.boxCollege.nativeElement).style.cursor = 'pointer';
    } catch (err) {}
  }

  onChangeEvent(event: any) {
    const val = event.target.value;
    this.allData = this.colleges;
    if (val) {
      this.searchData = this.allData.filter((item: any) =>
        (item.collage_name || '').toLowerCase().includes(val.toLowerCase())
      );
    }
    if (!this.searchData || this.searchData.length === 0) {
      this.globalService.showError('Data Not Found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  // open add modal, ensure scopes are loaded before showing
  async openAdd() {
    try {
      this.addCollegeForm.reset();
      this.addCollegeForm.patchValue({ preVal: 1 });
      this.imageUrl =
        this.commonservice?.base64profile || 'assets/tenant-avatar.jpg';
      this.images = [];
      this.galleryFiles = [];
      this.scopeIdArray = [];
      this.hint = '';
      this.preferenceVal = 1;

      // ensure scope list is ready before showing modal
      await this.loadScopesIfNeeded();

      // open modal only after scopes loaded
      this.setModalOpen(true);
      this.showAdd = true;
      this.showEdit = false;

      // prevent body scroll while modal open
      document.body.classList.add('modal-open');

      // sync component props (minimal)
      this.collegeName = '';
      this.address = '';
      this.city = '';
      this.stateid = '';
      this.objectives = '';
    } catch (err) {
      console.error('openAdd error', err);
      this.closeAllModals();
    }
  }

  viewCollege(data: any) {
    this.globalService.setLocalStore('collegeDetails', JSON.stringify(data));
    this.router.navigate(['/indCollege']);
  }

  viewAll() {
    this.router.navigate(['/addClgImgs']);
  }

  viewAllVideos() {
    this.router.navigate(['/adVideo']);
  }

  viewAllCourses() {
    this.router.navigate(['/addcourseCollege']);
  }

  addMultiImgs(event: any) {
    this.handleFileInputs(event);
  }

  // Called when a scope checkbox is toggled in the UI.
  // Keeps scope.check synchronized and updates the reactive control checkVal
  onScopeToggle(scope: any) {
    scope.check = !scope.check;
    // set the reactive form's checkVal to true if at least one checkbox is selected
    const anyChecked = (this.scopeData || []).some((s: any) => !!s.check);
    try {
      const control = this.addCollegeForm.get('checkVal');
      if (control) control.setValue(anyChecked);
    } catch (e) {
      console.warn('onScopeToggle setValue error', e);
    }
  }

  onCheckChange(event: any) {
    // kept intentionally empty - component reads scopeData[].check directly
  }

  hint: any = '';

  private markAllControlsTouched() {
    Object.keys(this.addCollegeForm.controls).forEach((k) => {
      this.addCollegeForm.get(k)?.markAsTouched();
    });
  }

  addCollege() {
    console.log('[colleges] addCollege called');
    this.spinner.show();

    try {
      // Build scopeIdArray defensively from the scopeData check flags
      this.scopeIdArray = [];
      for (let i = 0; i < (this.scopeData || []).length; i++) {
        if (this.scopeData[i].id != null && this.scopeData[i].check) {
          this.scopeIdArray.push({
            scope_id: this.scopeData[i].id,
            fees: this.scopeData[i].fees,
            trust_fees: this.scopeData[i].trustFees,
          });
        }
      }

      // Update reactive control checkVal so form validity matches UI selection
      try {
        const hasAny = this.scopeIdArray.length > 0;
        const control = this.addCollegeForm.get('checkVal');
        if (control) control.setValue(hasAny);
      } catch (e) {
        console.warn('unable to set checkVal', e);
      }

      this.markAllControlsTouched();

      if (!this.addCollegeForm.valid) {
        this.spinner.hide();
        console.warn('[colleges] form invalid', this.addCollegeForm.value);
        this.globalService.showError(
          'Please correct form errors before submitting.'
        );
        return;
      }

      const fv = this.addCollegeForm.value;
      const payload: any = {
        college_name: fv.clgName || this.collegeName,
        state: fv.clgState || this.stateid,
        district: fv.clgDistrict || this.city,
        address: fv.clgAddress || this.address,
        scopes: this.scopeIdArray,
        description: fv.objectivesVal || this.objectives,
        user_image: this.imageUrl || null,
        smscap_eligible: fv.preVal ?? this.preferenceVal,
        hint: fv.hint || this.hint,
        images: this.images || [],
      };

      console.log('[colleges] payload:', payload);

      const servicePath = this.utils.getApiConfigs('college');
      this.commonservice
        .invokeService(servicePath[0].method, servicePath[0].path, payload)
        .then((resp: any) => {
          this.spinner.hide();
          console.log('[colleges] add college resp', resp);
          if (resp?.status_code == '200') {
            this.globalService.showSuccess('College Added Successfully');
            this.onCloseHandled();
            this.ngOnInit();
            this.addCollegeForm.reset();
            this.images = [];
            this.galleryFiles = [];
          } else if (resp?.status_code == '400') {
            this.globalService.showError(resp.data || resp.message || 'Error');
          } else {
            this.globalService.showError('Unexpected server response');
          }
        })
        .catch((err) => {
          console.error('[colleges] addCollege error', err);
          this.spinner.hide();
          this.globalService.showError('Failed to add college. Try again.');
        });
    } catch (err) {
      console.error('[colleges] addCollege unexpected error', err);
      this.spinner.hide();
      this.globalService.showError('Unexpected error. Try again.');
      this.closeAllModals();
    }
  }

  clearSearch(event?: Event) {
    if (event) event.stopPropagation();
    this.searchval = '';
    if (this.gridApi) (this.gridApi as any)?.setQuickFilter?.('');
    this.searchData = this.colleges || [];
  }

  onSearchInput(q: string) {
    this.searchval = q;
    if (this.gridApi && (this.gridApi as any).setQuickFilter) {
      (this.gridApi as any).setQuickFilter(q);
    }

    const list = this.colleges || [];

    if (!q || q.trim() === '') {
      this.searchData = list;
      if (!list || list.length === 0) {
        this.showNodata = true;
        this.showData = false;
      } else {
        this.showNodata = false;
        this.showData = true;
      }
      return;
    }

    const lowerQ = q.toLowerCase();
    this.searchData = list.filter((c: any) =>
      ((c.collage_name || '') as string).toLowerCase().includes(lowerQ)
    );

    if (!this.searchData || this.searchData.length === 0) {
      this.globalService.showError('Data Not Found');
    } else {
      this.showData = true;
      this.showNodata = false;
    }
  }

  editCollege(data: any) {
    try {
      this.setModalOpen(true);
      this.showAdd = false;
      this.showEdit = true;

      // keep id & preview image
      this.id = data.id;
      this.imageUrl = data.image || this.imageUrl;

      // patch reactive form controls precisely (names must match FormGroup)
      this.addCollegeForm.patchValue({
        clgName: data.collage_name ?? '',
        clgAddress: data.address ?? '',
        clgDistrict: data.district ?? '',
        clgState: data.state ?? '',
        objectivesVal: data.description ?? '',
        hint: data.hint ?? '',
        preVal: data.smscap_eligible ?? 1,
      });

      // sync component props for any remaining template bindings
      this.collegeName = data.collage_name ?? '';
      this.address = data.address ?? '';
      this.city = data.district ?? '';
      this.stateid = data.state ?? '';
      this.objectives = data.description ?? '';
      this.hint = data.hint ?? '';
      this.preferenceVal = data.smscap_eligible ?? 1;

      // If there are scope selections in the incoming data, map them to scopeData.check
      try {
        if (Array.isArray(this.scopeData) && Array.isArray(data.scopes)) {
          // data.scopes might be objects like { scope_id: 'x' } or numbers; normalize
          const selectedScopeIds = data.scopes.map((s: any) =>
            s && s.scope_id != null ? String(s.scope_id) : String(s)
          );
          this.scopeData.forEach((sd: any) => {
            sd.check = selectedScopeIds.includes(String(sd.id));
          });
        }
      } catch (e) {
        // no-op if shapes differ
      }

      console.log('[editCollege] form after patch:', this.addCollegeForm.value);

      // ensure update is detected
      try {
        this.cdr.detectChanges();
      } catch (e) {}

      document.body.classList.add('modal-open');
    } catch (err) {
      console.error('[editCollege] error:', err);
      this.closeAllModals();
    }
  }

  updateCollege() {
    this.spinner.show();
    try {
      this.markAllControlsTouched();

      const fv = this.addCollegeForm.value;
      const payload: any = {
        id: this.id,
        collage_name: fv.clgName || this.collegeName,
        state: fv.clgState || this.stateid,
        district: fv.clgDistrict || this.city,
        address: fv.clgAddress || this.address,
        contact_no: this.phonenumber,
        contact_email: this.emailAddress,
        description: fv.objectivesVal || this.objectives,
        hint: fv.hint || this.hint,
      };

      if (this.imageTrueFalse && this.imageUrl) {
        payload.user_image = this.imageUrl;
      }

      const servicePath = this.utils.getApiConfigs('editcollege');
      this.commonservice
        .invokeService(servicePath[0].method, servicePath[0].path, payload)
        .then((resp: any) => {
          this.spinner.hide();
          if (resp?.status_code == '200') {
            this.globalService.showSuccess(
              'College details updated Successfully'
            );
            this.onCloseHandled();
            this.ngOnInit();
            this.addCollegeForm.reset();
            this.imageTrueFalse = false;
            this.images = [];
            this.galleryFiles = [];
          } else if (resp?.status_code == '400') {
            this.globalService.showError(resp.data || resp.message || 'Error');
          } else {
            this.globalService.showError('Unexpected server response');
          }
        })
        .catch((err) => {
          console.error('updateCollege error', err);
          this.spinner.hide();
          this.globalService.showError('Failed to update college. Try again.');
          this.closeAllModals();
        });
    } catch (err) {
      console.error('updateCollege unexpected error', err);
      this.spinner.hide();
      this.closeAllModals();
    }
  }

  deleteCollege(data: any) {
    try {
      this.deleteErr = '';
      this.setDeleteOpen(true);
      this.id = data.id;
      document.body.classList.add('modal-open');
    } catch (err) {
      console.error('deleteCollege error', err);
      this.closeAllModals();
    }
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    const servicePath = this.utils.getApiConfigs('deletecollege');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp?.status_code == '200') {
          this.globalService.showSuccess(resp.data);
          this.setDeleteOpen(false);
          this.closeAllModals();
          this.ngOnInit();
        } else if (resp?.status_code == '400') {
          this.showErr = true;
          this.deleteErr = resp.message;
        } else {
          this.globalService.showError('Unexpected server response');
        }
      })
      .catch((err) => {
        console.error('delete error', err);
        this.spinner.hide();
        this.closeAllModals();
      });
  }

  onCloseHandled() {
    this.setModalOpen(false);
    this.setDeleteOpen(false);
    this.showAdd = false;
    this.showEdit = false;

    this.addCollegeForm.reset();
    this.images = [];
    this.galleryFiles = [];
    this.imageTrueFalse = false;
    this.fileToUpload = null;

    try {
      document.body.classList.remove('modal-open');
    } catch (e) {}
  }
}
